import axios from 'axios';

import { getData, getQueryKey } from '@feature/utils';

import { Nomenclature } from './NomenclatureTypes';

export interface NomenApi<T = unknown> {
  getAll: () => Promise<Nomenclature<T>[]>;
}

export function generateNomenApi<T = unknown>(baseUrl: string) {
  return {
    getAll: () => axios.get<Nomenclature<T>[]>(`${baseUrl}`).then(getData),
  };
}

export function generateNomenOptions<T = unknown>(keyRoot: string, api: NomenApi<T>) {
  const nomenKey = getQueryKey(keyRoot);

  return {
    getAll: () => ({
      queryKey: nomenKey.list(),
      queryFn: () => api.getAll(),
    }),
  };
}
